module.exports = __webpack_public_path__ + "img/boggart_turned_into_a_dementor.2c715d82.jpg";